// Converted from analyticsCreatePiin.js
import { RouteProp } from '@react-navigation/native';
import AmplitudeHelper from '@utils/analytics';
import { AMPLITUDE_CONSTANTS } from '@utils/analytics/constants';

// Define a generic type for route.params
interface SourceRouteParams {
  source?: string;
  pin_failed_modal?: string;
}

type GenericRoute = RouteProp<Record<string, { params?: SourceRouteParams }>, string>;

export function logHelpClicked(): void {
  const e = AMPLITUDE_CONSTANTS.authentication.help_clicked;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.source]: 'pin_phone_number',
  });
}

export function logOnPage(getPageNumber: () => number, route: GenericRoute): void {
  const e = AMPLITUDE_CONSTANTS.securityPin.pin_page;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.page_number]: getPageNumber(),
    [e.attributes.source]: route.params?.source,
  });
}

export function logHelpCheckCreatePin(route: GenericRoute): void {
  const e = AMPLITUDE_CONSTANTS.securityPin.help_clicked;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.source]: route.params?.source,
  });
}

export function logCloseModal(route: GenericRoute): void {
  const e = AMPLITUDE_CONSTANTS.securityPin.x_button_clicked;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.source]: route.params?.pin_failed_modal,
  });
}

export function logPrimaryPress(route: GenericRoute): void {
  const e = AMPLITUDE_CONSTANTS.securityPin.reset_pin_later;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.source]: route.params?.pin_failed_modal,
  });
}

export function logReCreatePin(route: GenericRoute): void {
  const e = AMPLITUDE_CONSTANTS.securityPin.recreate_pin_clicked;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.source]: `${route.params?.source}_modal`,
  });
}

export function logResetPinClicked(route: GenericRoute): void {
  const e = AMPLITUDE_CONSTANTS.securityPin.reset_pin_clicked;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.source]: route.params?.pin_failed_modal,
  });
}

export function logBankClicked(source: string): void {
  const e = AMPLITUDE_CONSTANTS.securityPin.add_bank_account_clicked;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.source]: source,
  });
}

export function logAddPhoneClicked(source: string): void {
  const e = AMPLITUDE_CONSTANTS.securityPin.add_phonenumber_clicked;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.source]: source,
  });
}

export function logChangePhoneClicked(source: string): void {
  const e = AMPLITUDE_CONSTANTS.securityPin.phone_phonenumber_clicked;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.source]: source,
  });
}

export function logOkCreate(route: GenericRoute): void {
  const e = AMPLITUDE_CONSTANTS.securityPin.ok_button_clicked;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.source]: `${route.params?.source}_submitted_modal`,
  });
}

export function logPinCreationFailedFinal(route: GenericRoute, getPageNumber: () => number): void {
  const e = AMPLITUDE_CONSTANTS.securityPin.pin_creation_failed;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.source]: route.params?.source,
    [e.attributes.page_number]: getPageNumber(),
    [e.attributes.failure_message]: 'pin_repeated',
  });
}

export function logPinSubmitted(route: GenericRoute): void {
  const e = AMPLITUDE_CONSTANTS.securityPin.pin_submitted;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.source]: route.params?.source,
  });
}

export function logContinueButtonClicked(route: GenericRoute): void {
  const e = AMPLITUDE_CONSTANTS.securityPin.continue_button_clicked;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.source]: route.params?.source,
  });
}

export function logPinCreationFailed(route: GenericRoute, getPageNumber: () => number, invalidConfirms: number): void {
  const e = AMPLITUDE_CONSTANTS.securityPin.pin_creation_failed;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.source]: route.params?.source,
    [e.attributes.page_number]: getPageNumber(),
    [e.attributes.failure_message]: `wrong_pin${invalidConfirms + 1}`,
  });
}

export function logPinInputted(route: GenericRoute): void {
  const e = AMPLITUDE_CONSTANTS.securityPin.pin_inputted;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.source]: route.params?.source,
  });
}

export function logPinCreationInputted(getPageNumber: () => number, route: GenericRoute): void {
  const e = AMPLITUDE_CONSTANTS.securityPin.pin_creation_inputted;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.page_number]: getPageNumber(),
    [e.attributes.source]: route.params?.source,
  });
}

export function logPinInputFailed(route: GenericRoute, securityPin: { invalidAttempts: number }): void {
  const e = AMPLITUDE_CONSTANTS.securityPin.pin_inputted_failed;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.source]: route.params?.source,
    [e.attributes.attempt]: `${securityPin.invalidAttempts + 1}`,
  });
}

export function logXButtonClickedSubmitted(route: GenericRoute): void {
  const e = AMPLITUDE_CONSTANTS.securityPin.x_button_clicked;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.source]: `${route.params?.source}_submitted_modal`,
  });
}

export function logCloseModalSource(route: GenericRoute): void {
  const e = AMPLITUDE_CONSTANTS.securityPin.x_button_clicked;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.source]: `${route.params?.source}_modal`,
  });
}

export function logPinInputSuccessfully(route: GenericRoute): void {
  const e = AMPLITUDE_CONSTANTS.securityPin.pin_inputted_successfully;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.source]: route.params?.source,
  });
}
